import React, { useMemo } from 'react';
import BagIcon from '@material-ui/icons/LocalMallOutlined';
import classes from './styles.module.css';
import DIMENSIONS from '@app/config/dimensions';
import { getBRCurrencyFormat } from '@app/utils/formmater';
import { useBagContext } from '@app/contexts/Bag';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { Restaurant } from '@material-ui/icons';
import cls from 'classnames';
import { TagManager } from '@app/utils/tag-manager';

type Props = {
  amount: number;
  onSeeClick: () => void;
};
export default function BagBar({ amount, onSeeClick }: Props) {
  const { isAInternalMenuOrOrderedOnRestaurant } = useRestaurantContext();
  const { totalItemsPrice } = useBagContext();

  return (
    <div className={classes.container} style={{ height: DIMENSIONS.BAG_BAR.HEIGHT }} onClick={onSeeClick}>
      <div>
        <div className={classes.amount}>
          <span>{amount}</span>
        </div>
        <span className={classes.total}>{getBRCurrencyFormat(totalItemsPrice)}</span>
      </div>
      <button className={cls(classes.button, TagManager.Classes.InitiateCheckout)}>
        <span className={TagManager.Classes.InitiateCheckout}>
          {isAInternalMenuOrOrderedOnRestaurant ? 'VER ESCOLHAS' : 'VER SACOLA'}
        </span>
        {isAInternalMenuOrOrderedOnRestaurant ? (
          <Restaurant fontSize="small" className={TagManager.Classes.InitiateCheckout} />
        ) : (
          <BagIcon fontSize="small" className={TagManager.Classes.InitiateCheckout} />
        )}
      </button>
    </div>
  );
}
